import { Controller } from "stimulus";

export default class extends Controller {
  static values = { url: String, copiedText: String };
  static targets = ["label"];

  copy(event) {
    event.preventDefault();
    const url = this.urlValue || window.location.href;
    navigator.clipboard.writeText(url).then(() => {
      this.element.dataset.copied = 'true';
      if (this.hasLabelTarget && this.copiedTextValue) {
        if (this.originalLabel === undefined) this.originalLabel = this.labelTarget.textContent;
        this.labelTarget.textContent = this.copiedTextValue;
      }
      clearTimeout(this.resetTimer);
      this.resetTimer = setTimeout(() => {
        delete this.element.dataset.copied;
        if (this.hasLabelTarget && this.originalLabel !== undefined) {
          this.labelTarget.textContent = this.originalLabel;
        }
      }, 1500);
    });
  }
}
